import Cookies from 'js-cookie'
import {ContactUsValue, contactUs} from '../helper/ContactUsInfo'
import DynamicObject from '../../models/dynamic-object'
import {PROMOTE} from '../helper/Ctas'
import {SocialUrlsValue, socialUrls} from '../helper/SocialUrlsInfo'
import {trackEvent} from '../../gtm/trackEvent'
import Api from '../../api/api'
import shortUrlApi from '../../api/site/shortUrl.api'
import {DEFAULT_AVATAR, NO_IMAGE, NO_IMAGE_SHOBIDAK} from '../helper/ImagePaths'
import {IMAGE_PREVIEW_SM} from '../helper/ImageSize'
import Auth from 'opensooq-sso'
import {resetSocket} from '../modules/socket-v5/providers/socketService'
import {logEditListingClick} from '../../logging/helpers/commonLoggingFunctions'
import {EnumUxTypes, UTM_DATA} from '../../logging/types/LoggingTypes'
import getProfileApi from '../../api/profile/getProfile.api'
import {SessionDimensions} from '../../logging/dimensions/SessionDimensions'
import {generateABBucket} from './generateAbbucket'
import {clearSharedTokenPromise, generateToken} from '../../newApp/helpers/auth'
import { getQueryParams } from '../../logging/hooks/useLogging'
import { CAMPAIGN_PAYLOAD_KEYS, toCampaignQueryEntries, toCampaignQueryParams } from '../../logging/helpers/campaignPayload'

const getDomainWithoutSubdomain = (url: string) => {
  const urlParts = new URL(url).hostname.split('.')
  return urlParts
    .slice(0)
    .slice(-(urlParts.length === 4 ? 3 : 2))
    .join('.')
}

function preloadImage(src: string, stateSetter: (src: string) => void) {
  return new Promise<string>((resolve, reject) => {
    const img = new Image()
    img.onload = function () {
      stateSetter(img.src)
    }
    img.onerror = img.onabort = function () {
      stateSetter(DEFAULT_AVATAR)
    }
    img.setAttribute('fetchpriority', 'high')
    img.src = src
  })
}

const initiateLogout = async () => {
  const newAuth = Auth.getInstance()
  newAuth.init(
    getOriginDomain(),
    'sso',
    getCookies().NEXT_LOCALE === 'ku' ? 'ar': getCookies().NEXT_LOCALE,
    getCookies().ecountry,
    getCookies().source,
    getCookies().device_uuid,
    getCookies().cityId
  )
  await Auth.getInstance().destroy()
}

const initiateLogin = async () => {
  const newAuth = Auth.getInstance()
  await newAuth.init(
    getOriginDomain(),
    'sso',
    getCookies().NEXT_LOCALE === 'ku' ? 'ar': getCookies().NEXT_LOCALE,
    getCookies().ecountry,
    getCookies().source,
    getCookies().device_uuid,
    getCookies().cityId
  )
  clearSharedTokenPromise()
  await generateToken()
}

const api401Handler = async () => {
  // await initiateLogout();
  await initiateLogin()
}

const logout = async () => {
  resetSocket()
  const newAuth = Auth.getInstance()
  newAuth.init(
    getOriginDomain(),
    'sso',
    getCookies().NEXT_LOCALE === 'ku' ? 'ar': getCookies().NEXT_LOCALE,
    getCookies().ecountry,
    getCookies().source,
    getCookies().device_uuid,
    getCookies().cityId
  )
  await Auth.getInstance().destroy()
  // window.location.href = process.env.REACT_APP_OPENSOOQ_LOGOUT_URL?.replace("{country}",getCookies().ecountry ?? 'jo').replace("{lang}",getCookies().NEXT_LOCALE) ?? '';
}

const getSocialUrlsByCountry = (country: string): SocialUrlsValue => {
  return country in socialUrls ? socialUrls[country] : socialUrls['default']
}

const getContactUsByCountry = (country: string): ContactUsValue => {
  return country in contactUs ? contactUs[country] : contactUs['default']
}

const redirectOut = (url: string) => {
  window.open(url, '_blank')
}

const generateOpenSooqRedirectUrl = (url?: string, country?: string, lang?: string) => {
  let redirectTo = url?.replace('{country}', country ?? '').replace('{lang}', lang ?? '')
  if (isShobiddak()) {
    redirectTo = url?.replace('{country}.', '').replace('/{lang}', '')
  }
  return redirectTo+""
}

const redirectionInterceptor = () => {
  const utmData = extractUtms()
  const utmSender: Record<string, string> = {}

  if (utmData.cSource) {
    utmSender.cSource = utmData.cSource
  }
  if (utmData.cMedium) {
    utmSender.cMedium = utmData.cMedium
  }
  if (utmData.cCampaign) {
    utmSender.cName = utmData.cCampaign
  }

  setCookie('utmSender', JSON.stringify(utmSender), defaultOptions)
}

const formateDate = (date: string) => {
  const timestamp = Number.parseInt(date, 10)
  if (Number.isNaN(timestamp)) {
    return ''
  }

  const parsedDate = new Date(timestamp * 1000)
  if (Number.isNaN(parsedDate.getTime())) {
    return ''
  }

  const day = parsedDate.getDate().toString().padStart(2, '0')
  const month = (parsedDate.getMonth() + 1).toString().padStart(2, '0')
  const year = parsedDate.getFullYear()
  const hours = parsedDate.getHours().toString().padStart(2, '0')
  const minutes = parsedDate.getMinutes().toString().padStart(2, '0')

  return day + '-' + month + '-' + year + ' ' + hours + ':' + minutes
}

const canTakeAction = (ctas: DynamicObject, action: string) => {
  return ctas?.find((cta: DynamicObject) => {
    return cta.cta === action
  })
}

const takeAction = (cta: string, listingId: number) => {
  if (cta === PROMOTE) {
  }
}

export type LiteUserInfo = {
  id: number
  full_name: string
  profile_picture: string
  phone_number: string
  member_type: number
  shopName?: string
  hasPassword?: boolean
}

export type AuthTicketType = {
  t: number
  k: string
}

export const jsonSafeGet = <T>(jsonString: any, defaultData = {}): T => {
  let output = defaultData as T
  try {
    output = JSON.parse(jsonString)
  } catch (e) {
    // do nothing.
  }
  return output
}

const UTM_DATA_STORAGE_KEY = 'utmData'
const UTM_SESSION_STORAGE_KEY = 'utmDataSession'
const UTM_STALE_URL_DATA_KEY = 'utmDataStaleUrl'

const DEFAULT_UTM_DATA: UTM_DATA = {
  cSource: 'opensooq',
  cMedium: 'none',
  cCampaign: 'direct_web_open',
}

const EMPTY_UTM_DATA: UTM_DATA = {
  cSource: '',
  cMedium: '',
  cCampaign: '',
}

let hasSyncedUtmDataForCurrentDocument = false

type SessionCookieIdentity = {id: string; startedAt: string}

export const getEmptyUtmData = (): UTM_DATA => ({...EMPTY_UTM_DATA})

const isDefaultUtmData = (utmData: UTM_DATA) =>
  utmData.cSource === DEFAULT_UTM_DATA.cSource &&
  utmData.cMedium === DEFAULT_UTM_DATA.cMedium &&
  utmData.cCampaign === DEFAULT_UTM_DATA.cCampaign


export const withoutDefaultUtmData = (utmData: UTM_DATA): UTM_DATA =>
  isDefaultUtmData(utmData) ? getEmptyUtmData() : {...utmData}

export const hasUtmData = (utmData: UTM_DATA) =>
  Boolean(utmData.cSource || utmData.cMedium || utmData.cCampaign)

const getUtmDataFromQuery = (): UTM_DATA => {
  const query = getQueryParams()

  return {
    cSource: query.get('cSource') || query.get('utm_source') || '',
    cMedium: query.get('cMedium') || query.get('utm_medium') || '',
    cCampaign: query.get('cName') || query.get('utm_campaign') || '',
  }
}

const getStoredUtmData = (): UTM_DATA => {
  const storedUtmData = jsonSafeGet<Partial<UTM_DATA>>(sessionStorage.getItem(UTM_DATA_STORAGE_KEY))

  return {
    cSource: storedUtmData?.cSource || '',
    cMedium: storedUtmData?.cMedium || '',
    cCampaign: storedUtmData?.cCampaign || '',
  }
}

const markCurrentUrlUtmsAsStale = () => {
  const urlUtmData = getUtmDataFromQuery()

  if (!hasUtmData(urlUtmData)) {
    sessionStorage.removeItem(UTM_STALE_URL_DATA_KEY)
    return
  }

  sessionStorage.setItem(UTM_STALE_URL_DATA_KEY, JSON.stringify(urlUtmData))
}

const getStaleUtmData = (): UTM_DATA => {
  const staleUtmData = jsonSafeGet<Partial<UTM_DATA>>(sessionStorage.getItem(UTM_STALE_URL_DATA_KEY))

  return {
    cSource: staleUtmData?.cSource || '',
    cMedium: staleUtmData?.cMedium || '',
    cCampaign: staleUtmData?.cCampaign || '',
  }
}

// Stale as long as the url brings nothing the previous session did not already have. A
// single new value means a new campaign arrived, and then the whole set is taken so a
// partial one is never sent.
const isStaleUtmData = (utmData: UTM_DATA) => {
  const staleUtmData = getStaleUtmData()

  if (!hasUtmData(utmData) || !hasUtmData(staleUtmData)) {
    return false
  }

  return (!utmData.cSource || utmData.cSource === staleUtmData.cSource) &&
    (!utmData.cMedium || utmData.cMedium === staleUtmData.cMedium) &&
    (!utmData.cCampaign || utmData.cCampaign === staleUtmData.cCampaign)
}

export const getUtmDataFromUrl = (): UTM_DATA => {
  syncUtmDataWithCurrentSession()

  const urlUtmData = getUtmDataFromQuery()

  return isStaleUtmData(urlUtmData) ? getEmptyUtmData() : withoutDefaultUtmData(urlUtmData)
}

const isNavigatedDocument = () => {
  const [navigationEntry] = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[]

  return !navigationEntry || navigationEntry.type === 'navigate'
}

const asIdentityValue = (value?: string | number | null) =>
  value === undefined || value === null ? '' : String(value)

export const getCurrentSessionCookieIdentity = (): SessionCookieIdentity | null => {
  const rawSession = Cookies.get('session')

  if (!rawSession) {
    return null
  }

  const session = jsonSafeGet<{id?: string | number; startedAt?: number | string}>(rawSession)

  if (!session?.id) {
    return {id: rawSession, startedAt: ''}
  }

  return {
    id: asIdentityValue(session.id),
    startedAt: asIdentityValue(session.startedAt),
  }
}

const getSessionIdentitySignature = (sessionIdentity: SessionCookieIdentity) =>
  `${sessionIdentity.id}|${sessionIdentity.startedAt}`

const getStoredSessionIdentitySignature = () => {
  const storedValue = sessionStorage.getItem(UTM_SESSION_STORAGE_KEY)

  if (!storedValue) {
    return ''
  }

  const storedSession = jsonSafeGet<Partial<SessionCookieIdentity>>(storedValue)

  if (!storedSession?.id && !storedSession?.startedAt) {
    return storedValue
  }

  return getSessionIdentitySignature({
    id: asIdentityValue(storedSession.id),
    startedAt: asIdentityValue(storedSession.startedAt),
  })
}

export const syncUtmDataWithCurrentSession = (): boolean => {
  const currentSession = getCurrentSessionCookieIdentity()

  if (!currentSession) {
    return false
  }

  const currentSignature = getSessionIdentitySignature(currentSession)
  const storedSignature = getStoredSessionIdentitySignature()
  const hasStoredUtmData = Boolean(sessionStorage.getItem(UTM_DATA_STORAGE_KEY))
  const missingSessionForStoredUtmData = !storedSignature && hasStoredUtmData
  const sessionChanged = missingSessionForStoredUtmData ||
    (Boolean(storedSignature) && storedSignature !== currentSignature)

  if (sessionChanged) {
    sessionStorage.removeItem(UTM_DATA_STORAGE_KEY)
    SessionDimensions.clearUtmDimensions()
  }

  const isFirstSyncForCurrentDocument = !hasSyncedUtmDataForCurrentDocument
  hasSyncedUtmDataForCurrentDocument = true

  if (isFirstSyncForCurrentDocument && isNavigatedDocument()) {
    sessionStorage.removeItem(UTM_STALE_URL_DATA_KEY)
  } else if (sessionChanged) {
    markCurrentUrlUtmsAsStale()
  }

  // Every read syncs, so the identity is only written when it actually moved.
  if (storedSignature !== currentSignature) {
    sessionStorage.setItem(UTM_SESSION_STORAGE_KEY, JSON.stringify(currentSession))
  }

  return Boolean(sessionChanged)
}

type CookiesDataTypes = {
  userInfo: LiteUserInfo
  tgtTimestamp: any
  tgtTicket: any
  ecountry: string
  source: string
  device_uuid: string
  NEXT_LOCALE: string
  VIEWED_LISTING_COOKIE: string
  audience: string
  cityId: string
  lastContacted: any
  alert_message: string
  show_success_delete: string
  popupAppearanceDays?:any;
  saveUserProfileData?: string
  clickedOnMyListings?: string
  session:{id:string,startedAt:number}
}

export const isDeviceMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent || ''
  )
}

const getCookies = () => {
  const data : CookiesDataTypes  =  {
      userInfo: jsonSafeGet<LiteUserInfo>(Cookies.get('userInfo')),
      tgtTimestamp: jsonSafeGet<AuthTicketType>(Cookies.get('auth')).t || Cookies.get('tgt_timestamp'),
      tgtTicket: jsonSafeGet<AuthTicketType>(Cookies.get('auth')).k || Cookies.get('tgt_ticket'),
      ecountry: Cookies.get('ecountry') ?? '',
      source : Cookies.get('source') || Cookies.get('source') || (isDeviceMobile() ? 'mobile' : 'desktop'),
      device_uuid: Cookies.get('device_uuid') ?? '',
      NEXT_LOCALE:Cookies.get('NEXT_LOCALE') === 'ku' ? 'ar' : Cookies.get('NEXT_LOCALE') ?? 'ar',
      VIEWED_LISTING_COOKIE:Cookies.get('recentlyViewed') ?? 'recentlyViewed',
      audience:  Cookies.get('source') || (isDeviceMobile() ? 'mobile' : 'desktop'),
      cityId : Cookies.get('cityId') || '',
      lastContacted : Cookies.get("lastContacted") ? JSON.parse(Cookies.get("lastContacted")) : [],
      alert_message: Cookies.get("alert_message") ?? "",
      show_success_delete: Cookies.get("show_success_delete") ?? "",
      saveUserProfileData : Cookies.get('saveUserProfileData') ?? "",
      clickedOnMyListings : Cookies.get('clickedOnMyListings') ,
      popupAppearanceDays : Cookies.get('popupAppearanceDays') ?? "[]",
      session: jsonSafeGet<{id:string,startedAt:number}>(Cookies.get('session')),
  }

  if (!Cookies.get('source')) {
    setCookie('source', isDeviceMobile() ? 'mobile' : 'desktop', defaultOptions)
  }

  return data
}

const checkIfLogin = (): boolean => {
  const appCookies: CookiesDataTypes = getCookies()
  if (appCookies.userInfo && appCookies.ecountry)
    return true
  return false
}

const defaultOptions = {
  expires: process.env.REACT_APP_DEFAULT_COOKIES_EXPIRED_IN_MINUTES,
  path: '/',
  ...(typeof window !== 'undefined'
    ? window.location.hostname.includes('localhost')
      ? {domain: window.location.hostname}
      : {
          domain:
            '.' +
            window.location.hostname.split('.').reverse()[1] +
            '.' +
            window.location.hostname.split('.').reverse()[0],
        }
    : {}),
}

const setCookie = (name: string, value: string, options: DynamicObject) => {
  // Default values for options:
  let {expires = '', path = '/', domain = ''} = options

  // If expires is a number, convert it to minutes and create a Date object:
  if (typeof expires === 'number') {
    const minutes = expires
    const now = new Date()
    now.setTime(now.getTime() + minutes * 60 * 1000)
    expires = now
  }

  // Construct the cookie string:
  let cookieString = `${name}=${value}`

  if (expires instanceof Date) {
    cookieString += `;expires=${expires.toUTCString()}`
  }

  if (path) {
    cookieString += `;path=${path}`
  }

  if (domain) {
    cookieString += `;domain=${domain}`
  }

  // Set the cookie:
  document.cookie = cookieString
}

const removeEmptyValues = (object: DynamicObject) => {
  for (var key in object) {
    if (object.hasOwnProperty(key)) {
      var value = object[key]
      if (value === null || value === undefined || value === '') {
        delete object[key]
      }
    }
  }
}

const deleteCookie = (name: string) => {
  document.cookie = `${name}=; Max-Age=0; path=/`
}

const logError = (error: any, url: string, path: string) => {
  const errorCode = error.response && error.response.status ? error.response.status : 0
  if (errorCode != 0) {
    const link = document.createElement('a')
    link.href = url
    trackEvent(errorCode, 'Error', path, url)
  }
}

const log404Error = (msg: string, errorType: string) => {
  return Api.getInstance().request.post(`logging/tech-log`, {
    level: errorType,
    category: 'My OS 404 Error',
    msg: msg,
  })
}

const shorten = async (data: DynamicObject) => {
  return shortUrlApi(data)
}

const getResolvedAddPostPointOfEntry = (fallback = "") => {
  const queryPointOfEntry = new URLSearchParams(window.location.search).get("point_of_entry")
  return queryPointOfEntry || Cookies.get("sessionFunnelPointOfEntry") || fallback
}

const getAddPostReturnUrl = (pointOfEntry = "") => {
  const resolvedPointOfEntry = pointOfEntry || getResolvedAddPostPointOfEntry()
  if (!resolvedPointOfEntry) return window.location.href

  try {
    const returnUrl = new URL(window.location.href)
    returnUrl.searchParams.set("point_of_entry", resolvedPointOfEntry)
    return returnUrl.toString()
  } catch {
    const separator = window.location.href.includes("?") ? "&" : "?"
    return `${window.location.href}${separator}point_of_entry=${encodeURIComponent(resolvedPointOfEntry)}`
  }
}

const getAddPostRefUrl = (pointOfEntry = "") => {
  const returnUrl = getAddPostReturnUrl(pointOfEntry)
  const queryParams = new URLSearchParams()
  // Resolved the same way as the add-post url itself, so the ref that add-post reads and
  // the params it is opened with can never disagree.
  const utmData = extractUtms()

  // The extra campaign keys go on first so the resolved utms below stay authoritative for
  // the three they own.
  toCampaignQueryEntries(SessionDimensions.getInstance().sessionCampaignPayload).forEach(
    ([key, value]) => {
      queryParams.set(key, value)
    }
  )

  if (utmData.cSource) {
    queryParams.set('utm_source', utmData.cSource)
  }
  if (utmData.cMedium) {
    queryParams.set('utm_medium', utmData.cMedium)
  }
  if (utmData.cCampaign) {
    queryParams.set('utm_campaign', utmData.cCampaign)
  }

  try {
    const refUrl = new URL(returnUrl)
    ;[...CAMPAIGN_PAYLOAD_KEYS, 'cSource', 'cMedium', 'cName'].forEach((param) => {
      refUrl.searchParams.delete(param)
    })
    queryParams.forEach((value, key) => {
      refUrl.searchParams.set(key, value)
    })
    return refUrl.toString()
  } catch {
    const utmQuery = queryParams.toString()
    if (!utmQuery) return returnUrl

    const separator = returnUrl.includes('?') ? '&' : '?'
    return returnUrl + separator + utmQuery
  }
}

const getAddPostIntegrationUrl = (
  lang: string,
  type: string,
  id: number,
  draftId: number,
  iframe = false,
  pointOfEntry?: string
) => {
  const fromMyOs = iframe ? '&from=my-opensooq' : ''
  const resolvedPointOfEntry = pointOfEntry || getResolvedAddPostPointOfEntry()
  const pointOfEntryParam = resolvedPointOfEntry ? `&point_of_entry=${encodeURIComponent(resolvedPointOfEntry)}` : ""
  const returnUrl = getAddPostReturnUrl(resolvedPointOfEntry)
  return `${process.env.REACT_APP_ADD_POST}?v=2&source=${
    getCookies().source
  }&lang=${lang}&flow=${type}&draft_id=${draftId}${fromMyOs}&post_id=${id}${pointOfEntryParam}&return=${encodeURIComponent(returnUrl)}&${extractAddPostQueryParams()}`
}

const setBackURLForAddPost = (pointOfEntry = "") => {
  setCookie('addPostRef', encodeURIComponent(getAddPostRefUrl(pointOfEntry)), defaultOptions)
}

const deleteCookieKey = (name: string) => {
  // Default values for options:
  let {expires = '', path = '/', domain = ''} = defaultOptions

  // Construct the cookie string:
  let cookieString = `${name}=`

  // set expiry
  cookieString += `; Max-Age=0`

  if (path) {
    cookieString += `;path=${path}`
  }

  if (domain) {
    cookieString += `;domain=${domain}`
  }

  // Set the cookie:
  document.cookie = cookieString
}

const editListing = (
  listing: DynamicObject,
  type: string,
  pointOfEntryOrWidgetName?: string,
  uxType?: EnumUxTypes
) => {
  let pointOfEntry = type === 'edit' ? '' : pointOfEntryOrWidgetName;
  if (type === 'edit') {
    pointOfEntry = logEditListingClick({
      id: listing.listing_id,
      service:
        listing.service_name && listing.service_name.length > 0
          ? listing.service_name[listing.service_name.length - 1]?.icon
          : '',
      category: {label: listing.category_reporting_name},
      city: {name: listing.city_label_en},
      country: listing.country_abbreviation,
      neighborhoodName: listing.neighborhood_name_en ?? '',
      subCategory: listing.subcategory_reporting_name,
      is_active:listing?.is_active
    }, uxType, pointOfEntryOrWidgetName)
  }
  setBackURLForAddPost(pointOfEntry)
  setTimeout(() => {
    window.location.href = getAddPostIntegrationUrl(
      getCookies().NEXT_LOCALE === 'ku' ? 'ar' : getCookies().NEXT_LOCALE,
      type,
      listing.listing_id ?? 0,
      listing.draft_id ?? 0,
      false,
      pointOfEntry
    )
  }, 200)
}

const editCv = (cv: DynamicObject, type: string) => {
  setBackURLForAddPost()
  window.location.href = getAddPostIntegrationUrl(
    getCookies().NEXT_LOCALE === 'ku' ? 'ar' : getCookies().NEXT_LOCALE,
    type,
    cv.equivalent_post_id ?? 0,
    cv.draft_id ?? 0,
    false
  )
}

const getNoImageLogo = (lang: string) => {
  let noImage = NO_IMAGE.replace('{lang}', lang)
  if (isShobiddak()) {
    noImage = NO_IMAGE_SHOBIDAK.replace('{lang}', lang)
  }
  return noImage
}

export const getImageUrl = (baseImageUrl, imageUri, userImageCorp) => {
  return `${baseImageUrl}${imageUri}`.replace('{size}', userImageCorp);
}

// Builds an image URL from the V2 arbok CDN using an eager-loaded preview
// variant instead of fetching the raw file from `originals/media`.
// eager variants: 700x0, 1024x0, 192x192_shop
export const getArbokMediaUrl = (uri?: string, size: string = '1024x0') => {
  return `${process.env.REACT_APP_ARBOK_URL_BASE_V2}previews/${size}/${uri}.jpg`;
}

// Builds a listing video URL from the chat/media CDN. Videos are served as-is
// (no image preview variant applies), so the uri is appended directly.
export const getArbokVideoUrl = (uri?: string) => {
  return `${process.env.REACT_APP_ARBOK_URL_BASE_V2}${uri}`;
}

const isShobiddak = () => {
  let isShowbidak = false
  if (getOriginDomain() === process.env.REACT_APP_SHOBIDAK_DOMAIN) {
    isShowbidak = true
  }
  return isShowbidak
}

const getOriginDomain = () => {
  var hostname = window.location.href // Get the hostname from the current URL
  var parts = hostname.split('.') // Split the hostname by periods
  if (parts.length > 2) {
    // Check if there is a subdomain
    hostname = parts.slice(1).join('.') // Remove the subdomain
  }
  return hostname
}

const getSiteCustomContent = (Intl: any) => {
  let content = {
    viewOnSite: Intl.formatMessage({id: 'common.viewOnOpenSooq'}),
    siteUrl: process.env.REACT_APP_MY_OPENSOOQ_DOMAIN,
    siteName: Intl.formatMessage({id: 'footer.openSooqName'}),
    aboutUsHeader: Intl.formatMessage({id: 'footer.openSooq'}),
    aboutUsContent: Intl.formatMessage({id: 'footer.aboutOpenSooq'}),
    mainPageTitle: Intl.formatMessage({id: 'myOpenSooq.title'}),
    backToSite: Intl.formatMessage({id: 'backTopOpenSooq'}),
    sitePlus: Intl.formatMessage({id: 'hidePromotionListingsText1'}),
    sitePlusDesc: Intl.formatMessage({id: 'products.openSooqBuyer.section2'}),
    backToSiteDomain: Intl.formatMessage({id: 'backToOpenSooqWebsite'}),
    serviceValue: Intl.formatMessage({id: 'products.ValueService'}),
    getVerified:Intl.formatMessage({id:'verification.getVerified'}),
    getVerifiedBusiness:Intl.formatMessage({id:"verification.getBusinessVerifiedText"})

  }
  if (isShobiddak()) {
    content = {
      viewOnSite: Intl.formatMessage({id: 'common.viewOnShobiddak'}),
      siteUrl: process.env.REACT_APP_SHOBIDAK_DOMAIN,
      siteName: Intl.formatMessage({id: 'footer.shobiddakName'}),
      aboutUsHeader: Intl.formatMessage({id: 'footer.shobiddak'}),
      aboutUsContent: Intl.formatMessage({id: 'footer.aboutShobiddak'}),
      mainPageTitle: Intl.formatMessage({id: 'shobiddakPageTitle'}),
      backToSite: Intl.formatMessage({id: 'backToShobiddak'}),
      sitePlus: Intl.formatMessage({id: 'shobiddakPlus'}),
      sitePlusDesc: Intl.formatMessage({id: 'products.openSooqBuyer.section2'}),
      backToSiteDomain: Intl.formatMessage({id: 'backToShobiddakDomain'}),
      serviceValue: Intl.formatMessage({id: 'products.shobiddak'}),
    }
  }
  return content
}

const showChatInCountry = () : boolean =>{
  return (isCountryIncluded() && isDomainIncluded());
}

const isCountryIncluded = () => {
  const ecountry = getCookies().ecountry
  const excludedCountriesString = process.env.REACT_APP_EXCLUDE_CHAT_FROM_COUNTRIES
  let excludedCountries: string[] = []
  let index = -1
  if (excludedCountriesString) {
    excludedCountries = excludedCountriesString.split(',')
    index = excludedCountries.findIndex(
      (country) => country.toLowerCase() === ecountry.toLowerCase()
    )
  }
  return index < 0 ? true : false
}

const isDomainIncluded = (): boolean => {
  let currentDomain = window.location.hostname
  let domainParts = currentDomain.split('.') // Split the domain into parts
  if (domainParts.length > 2) {
    currentDomain = domainParts.slice(1).join('.')
  }
  const excludedDomainsString = process.env.REACT_APP_EXCLUDE_CHAT_FROM_DOMAINS
  let excludedDomains: string[] = []
  let index = -1
  if (excludedDomainsString) {
    excludedDomains = excludedDomainsString.split(',')
    index = excludedDomains.findIndex(
      (country) => country.toLowerCase() === currentDomain.toLowerCase()
    )
  }
  return index < 0 ? true : false
}

const carseerAvailable = () => {
  const countriesStr: string = process.env.REACT_APP_CARSEER_COUNTRIES ?? ''
  const countries: string[] = countriesStr.split(',')
  let index: number = countries.findIndex(
    (country) => country.toLowerCase() === getCookies().ecountry.toLowerCase()
  )
  return index !== -1
}

const changePassword = async (newPassword: string) => {
  return Auth.getInstance().changePassword(newPassword)
}

const getImage = (imageName: string) => {
  return imageName && imageName.length == 12 && imageName.charAt(0) == 'u'
    ? DEFAULT_AVATAR
    : `${process.env.REACT_APP_ARBOK_URL + IMAGE_PREVIEW_SM}/` + imageName + '.webp'
}

const getApplicantImage = (imageName: string) => {
  if (!imageName) return DEFAULT_AVATAR
  return imageName && imageName.length == 12 && imageName.charAt(0) == 'u'
    ? DEFAULT_AVATAR
    : `${imageName.replace('{platform}', 'android').replace('{size}', 'xxh')}`
}

const getGeneralImage = (imageName: string) => {
  if (!imageName) return DEFAULT_AVATAR
  return imageName && imageName.length == 12 && imageName.charAt(0) == 'u'
    ? DEFAULT_AVATAR
    : `${imageName.replace('{platform}', 'android').replace('{size}', 'xxh')}`
}

const getCvImage = (imageName: string) => {
  return imageName && imageName.length == 12 && imageName.charAt(0) == 'u'
    ? DEFAULT_AVATAR
    : `${imageName.replace('{platform}', 'android').replace('{size}', 'xxh')}`
}

const getReportImage = (imageName: string) => {
  return imageName && imageName.length == 12 && imageName.charAt(0) == 'u'
    ? DEFAULT_AVATAR
    : `${imageName.replace('{platform}', 'android').replace('{size}', 'xxh')}`
}

const getCtaName = (object: DynamicObject, ctaName: string) => {
  let name = ''
  if (object && object.ctas) {
    object.ctas.map((cta: DynamicObject, index: number) => {
      if (cta.cta == ctaName) {
        name = cta.label
      }
    })
  }
  return name
}

const isEmailVerified = (memberVerification) => {
  if (memberVerification & 1) {
    return true
  }
  return false
}

const isValidEmail = (email: string) => {
  if (
    email?.match(
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
    )
  ) {
    return true
  }
  return false
}

const cvLabelAligner = (matchLabel: string) => {
  const reg = /^\d{1,3}%/g
  const matchValue = matchLabel.match(reg)
  if (matchValue && matchValue.length > 0)
    return matchLabel.replace(matchValue[0], '') + ' \u200E' + matchValue[0] + '\u200E'
  return matchLabel
}

const getProfileImage = () => {
  return '/media/avatar/profile_avatar.png'
}

let profilePromise = null

const getProfileFunction = async () => {
  if (!profilePromise) {
    profilePromise = (async () => {
      const response = await getProfileApi()
      profilePromise = null
      return response
    })()
  }
  return profilePromise
}

const hasNoPassword = () => {
  if (!getCookies().userInfo || (getCookies().userInfo && !getCookies().userInfo?.hasPassword)) {
    return true
  }
  return false
}

const generateDateRangeObject = (min: any, max: any, free: any, premium: any) => {
  const minDate = new Date(min)
  const maxDate = new Date(max)
  const series: any = {
    premium: [],
    free: [],
    singlePremiumCat: [],
    singleFreeCat: [],
    cat: [],
    catModified: [],
  }
  for (let d = new Date(minDate); d <= maxDate; d.setDate(d.getDate() + 1)) {
    let timestamp = Math.floor(d.getTime() / 1000)
    const newtimestamp = Number(d)
    const maxDate = new Date(newtimestamp)
    let newmax: any = maxDate.getTime()
    newmax = new Date(newmax * 1000)
    const yyyy = maxDate.getFullYear()
    const mm = (maxDate.getMonth() + 1).toString().padStart(2, '0')
    const dd = maxDate.getDate().toString().padStart(2, '0')
    const maxformattedDate = `${yyyy}-${mm}-${dd}`
    series.premium.push({x: new Date(maxformattedDate).getTime(), y: premium[timestamp] || 0})
    series.free.push({x: new Date(maxformattedDate).getTime(), y: free[timestamp] || 0})
    series.singlePremiumCat.push(premium[timestamp] || 0)
    series.singleFreeCat.push(free[timestamp] || 0)
    series.cat.push(formatDate(d))
    series.catModified.push(formatDate(d))
  }

  if (series.cat.length == 1) {
    series.singlePremiumCat = [0, 0, 0].concat(series.singlePremiumCat).concat([0, 0, 0])
    series.singleFreeCat = [0, 0, 0].concat(series.singleFreeCat).concat([0, 0, 0])

    // Get the current year dynamically
    let currentYear = new Date().getFullYear()

    // Parse the date string using the current year
    let baseDate = new Date(`${currentYear}/${series.cat[0]}`)

    // Array to hold the dates
    let dates = []

    // Loop to get dates 3 days before to 3 days after
    for (let i = -3; i <= 3; i++) {
      let tempDate = new Date(baseDate)
      tempDate.setDate(baseDate.getDate() + i)
      dates.push(formatDate(tempDate))
    }

    series.catModified = dates
  }

  return series
}

const generateAccountStatsDateRangeObject = (min: any, max: any, stats: any) => {
  const minDate = new Date(min)
  const maxDate = new Date(max)
  const series: any = {
    stats: [],
    cat: [],
  }
  for (let d = new Date(minDate); d <= maxDate; d.setDate(d.getDate() + 1)) {
    let timestamp = Math.floor(d.getTime() / 1000)
    const newtimestamp = Number(d)
    const maxDate = new Date(newtimestamp)
    let newmax: any = maxDate.getTime()
    newmax = new Date(newmax * 1000)
    const yyyy = maxDate.getFullYear()
    const mm = (maxDate.getMonth() + 1).toString().padStart(2, '0')
    const dd = maxDate.getDate().toString().padStart(2, '0')
    const maxformattedDate = `${yyyy}-${mm}-${dd}`
    series.stats.push({x: new Date(maxformattedDate).getTime(), y: stats[timestamp] || 0})
    series.cat.push(formatDate(d))
  }

  return series
}

const formatDate = (date: Date) => {
  let month = ('0' + (date.getMonth() + 1)).slice(-2) // Get month and add leading zero if needed
  let day = ('0' + date.getDate()).slice(-2) // Get day and add leading zero if needed
  return `${month}/${day}`
}

const extractQueryParams = () => {
  const resolvedUtmData = extractUtms()
  const userAbBucket = Cookies.get('userABBucket') || generateABBucket()
  const params: string[] = []

  if (resolvedUtmData.cSource) {
    params.push(`cSource=${encodeURIComponent(resolvedUtmData.cSource)}`)
  }
  if (resolvedUtmData.cCampaign) {
    params.push(`cName=${encodeURIComponent(resolvedUtmData.cCampaign)}`)
  }
  if (resolvedUtmData.cMedium) {
    params.push(`cMedium=${encodeURIComponent(resolvedUtmData.cMedium)}`)
  }
  params.push(`abBucket=${userAbBucket}`)

  return params.join('&')
}

// Add post is a separate app that reads the campaign off its own url, so the extra campaign
// keys ride along with that redirect only. Api calls stay on extractQueryParams.
const extractAddPostQueryParams = () => {
  const campaignParams = toCampaignQueryParams(
    SessionDimensions.getInstance().sessionCampaignPayload
  )

  return [extractQueryParams(), ...campaignParams].join('&')
}

const footerLinksMapper = {
  support: {
    ar: 'مساعدة',
    en: 'support',
    ku: 'مساعدة',
  },
  'contact-us': {
    ar: 'مساعدة/اتصل-بنا',
    en: 'support/contact-us',
    ku: 'support/contact-us',
  },
  'sales-representatives': {
    ar: 'مندوبي-المبيعات',
    en: 'sales-representatives',
    ku: 'sales-representatives',
  },
  'term-of-use': {
    ar: 'termOfUse',
    en: 'termOfUse',
    ku: 'termOfUse',
  },
  'privacy-policy': {
    ar: 'site/page?view=privacyPolicy',
    en: 'site/page?view=privacyPolicy',
    ku: 'site/page?view=privacyPolicy',
  },
  'safety-tips': {
    ar: 'قواعد-السلامة',
    en: 'safety-tips',
    ku: 'قواعد-السلامة',
  },
  'other-countries': {
    ar: 'ref=change_country_jo',
    en: 'ref=change_country_jo',
    ku: 'ref=change_country_jo',
  },
  'site-map': {
    ar: 'site-map',
    en: 'site-map',
    ku: 'site-map',
  },
  'our-products': {
    ar: 'الخدمات-الاعلانية',
    en: 'advertising-products',
    ku: 'الخدمات-الاعلانية',
  },
}

export const keepOnlyNumbers = (input: string): string => {
  return input.replace(/\D/g, '')
}

const deepLinks = {
  help: {
    ar: 'xx/help',
    en: 'xx/help',
    ku: 'xx/help',
  },
  contactUs: {
    ar: 'xx/contactUS',
    en: 'xx/contactUS',
    ku: 'xx/contactUS',
  },
}


const deepLinkHandler = (deepLink: string, target: string = '_blank') => {
  const requestUri = deepLink.replace("xx", getCookies().ecountry);
  const deepLinkBase =  generateOpenSooqRedirectUrl(process.env.REACT_APP_OPENSOOQ_BASE ?? '',getCookies().ecountry, getCookies().NEXT_LOCALE === 'ku' ? 'ar' : getCookies().NEXT_LOCALE)  + '/';
  const url = `${deepLinkBase}site/dl?requestUri=${requestUri}`;
  window.open(url,target);
}
// The single place utms are resolved for urls, payloads and api calls: the current url
// first, then what the session already captured. Nothing falls back to the default utms
// or to the in-memory logging dimensions, so a caller either gets a real campaign or
// nothing at all.
const extractUtms: () => UTM_DATA = () => {
  const urlUtmData = getUtmDataFromUrl()
  const storedUtmData = getStoredUtmData()

  return withoutDefaultUtmData({
    cSource: urlUtmData.cSource || storedUtmData.cSource,
    cMedium: urlUtmData.cMedium || storedUtmData.cMedium,
    cCampaign: urlUtmData.cCampaign || storedUtmData.cCampaign,
  })
}

export const formatDeviceManagementIconUrl = (
  icon: string,
  size: string = 'xxh',
  platform: string = 'android'
) => {
  return icon.replace('{platform}', platform).replace('{size}', size);
};

export type {CookiesDataTypes}
export {
  extractUtms,
  footerLinksMapper,
  getProfileImage,
  setBackURLForAddPost,
  getProfileFunction,
  preloadImage,
  isValidEmail,
  isEmailVerified,
  getReportImage,
  getCvImage,
  getCtaName,
  editCv,
  getApplicantImage,
  getImage,
  api401Handler,
  carseerAvailable,
  getOriginDomain,
  changePassword,
  generateToken,
  isShobiddak,
  getNoImageLogo,
  getSiteCustomContent,
  editListing,
  getAddPostIntegrationUrl,
  getResolvedAddPostPointOfEntry,
  getAddPostReturnUrl,
  shorten,
  log404Error,
  logError,
  deleteCookie,
  removeEmptyValues,
  generateOpenSooqRedirectUrl,
  getDomainWithoutSubdomain,
  logout,
  getContactUsByCountry,
  getSocialUrlsByCountry,
  redirectOut,
  formateDate,
  canTakeAction,
  takeAction,
  checkIfLogin,
  getCookies,
  defaultOptions,
  setCookie,
  showChatInCountry,
  cvLabelAligner,
  clearSharedTokenPromise,
  getGeneralImage,
  hasNoPassword,
  deleteCookieKey,
  extractQueryParams,
  extractAddPostQueryParams,
  redirectionInterceptor,
  generateDateRangeObject,
  generateAccountStatsDateRangeObject,
  deepLinkHandler,
  deepLinks,
}
